<template>
  <div v-if="show"
       class="advanced-filter"
  >
    <vue-query-builder v-model="localQuery"
                       :rules="rules"
                       :labels="czLabels"
    ></vue-query-builder>
    <div class="advanced-filter-controls">
      <button class="btn btn-primary"
              @click="applyFilter"
      >
        Potvrdit filtr
      </button>
    </div>
  </div>
</template>

<script>
import VueQueryBuilder from 'vue-query-builder'

export default {
    name: 'AdvancedFilter',
    components: { VueQueryBuilder },
    props: {
        cols: {
            type: Array,
            required: true,
        },
        value: {
            type: Object,
            required: false,
            default: () => {
                return {
                    logicalOperator: 'AND',
                    children: [],
                }
            },
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localQuery: { logicalOperator: 'AND', children: [] },
            czLabels: {
                matchType: 'Typ shody',
                matchTypes: [
                    { 'id': 'AND', 'label': 'Všechny (AND)' },
                    { 'id': 'OR', 'label': 'Některý (OR)' },
                ],
                addRule: 'Přidat pravidlo',
                removeRule: '&times;',
                addGroup: 'Přidat skupinu',
                removeGroup: '&times;',
                textInputPlaceholder: 'hodnota',
            },
        }
    },
    computed: {
        rules() {
            const rulesMap = {}

            this.cols.forEach(key => {
                if (key === null) return
                let label = key
                if (key === '_type') {
                    label = 'Typ'
                } else if (key === '_project') {
                    label = 'Projekt'
                } else {
                    const pt = this.$store.getters.propertyTypeByKey(key)
                    if (pt && pt.name) {
                        label = pt.name
                    }
                }

                rulesMap[key] = {
                    type: 'text',
                    id: key,
                    label: label,
                    operators: ['rovná se', 'nerovná se', 'obsahuje', 'neobsahuje', 'začíná na', 'končí na', 'je prázdné', 'není prázdné'],
                }
            })

            // Ensure any rule used in localQuery also exists in rules
            // to prevent vue-query-builder from crashing when a saved filter
            // contains a column that is currently not in this.cols
            const ensureRules = group => {
                if (!group || !group.children) return
                group.children.forEach(child => {
                    if (child.type === 'query-builder-rule' && child.query && child.query.rule) {
                        const ruleId = child.query.rule
                        if (!rulesMap[ruleId]) {
                            let label = ruleId
                            const pt = this.$store.getters.propertyTypeByKey(ruleId)
                            if (pt && pt.name) {
                                label = pt.name
                            }
                            rulesMap[ruleId] = {
                                type: 'text',
                                id: ruleId,
                                label: label + ' (Skrytý)',
                                operators: ['rovná se', 'nerovná se', 'obsahuje', 'neobsahuje', 'začíná na', 'končí na', 'je prázdné', 'není prázdné'],
                            }
                        }
                    } else if (child.type === 'query-builder-group' && child.query) {
                        ensureRules(child.query)
                    }
                })
            }

            ensureRules(this.localQuery)

            return Object.values(rulesMap)
        },
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal && newVal.logicalOperator) {
                    this.localQuery = JSON.parse(JSON.stringify(newVal))
                } else {
                    this.localQuery = { logicalOperator: 'AND', children: [] }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        applyFilter() {
            this.$emit('input', JSON.parse(JSON.stringify(this.localQuery)))
        },
    },
}
</script>

<style scoped>
.advanced-filter {
    padding: 10px;
    background: #f9f9f9;
    border-bottom: 1px solid #ddd;
}
.advanced-filter-controls {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
}
</style>

<style>
/* Unscoped overrides for vue-query-builder */
.advanced-filter .vqb-group {
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    padding: 1rem;
    margin-bottom: 1rem;
    background: white;
}
.advanced-filter .vqb-group-heading {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: flex-end;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #edf2f7;
}
.advanced-filter .vqb-group-heading .form-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: flex-end;
}
.advanced-filter .vqb-group-body {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}
.advanced-filter .vqb-rule {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    border: 1px solid #edf2f7;
    background: #f8fafc;
    border-radius: 0.25rem;
    position: relative;
    min-width: 200px;
}
.advanced-filter .vqb-rule .form-group {
    margin-bottom: 0;
}
.advanced-filter .vqb-rule > .btn {
    align-self: flex-end;
}
.advanced-filter .vqb-rule .close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    padding: 0;
    margin: 0;
}
.vue-query-builder .vqb-group .rule-actions {
   margin-bottom: 20px;
 }

.vue-query-builder .vqb-rule {
  margin-top: 15px;
  margin-bottom: 15px;
  background-color: #f5f5f5;
  border-color: #ddd;
  padding: 15px;
}

.vue-query-builder .vqb-group.depth-1 .vqb-rule,
.vue-query-builder .vqb-group.depth-2 {
  border-left: 2px solid #8bc34a;
}

.vue-query-builder .vqb-group.depth-2 .vqb-rule,
.vue-query-builder .vqb-group.depth-3 {
  border-left: 2px solid #00bcd4;
}

.vue-query-builder .vqb-group.depth-3 .vqb-rule,
.vue-query-builder .vqb-group.depth-4 {
  border-left: 2px solid #ff5722;
}

.vue-query-builder .close {
  opacity: 1;
  color: rgb(150,150,150);
}

@media (min-width: 768px) {
  .vue-query-builder .vqb-rule.form-inline .form-group {
    display: block;
  }
}
.advanced-filter .form-inline .form-group {
  flex-flow: unset !important;
}
.advanced-filter .form-inline {
  flex-flow: unset !important;
}
</style>
